export default [
  {
    text: 'venue.panicModeHistory.startAt',
    value: 'panicStartAt',
    default: true,
    defaultOnMobile: true,
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
    sortable: true,
  },
  {
    text: 'venue.panicModeHistory.endAt',
    value: 'panicEndAt',
    default: true,
    defaultOnMobile: true,
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
    sortable: true,
  },
  {
    text: 'venue.panicModeHistory.reason',
    value: 'panicReason',
    default: true,
    defaultOnMobile: true,
    sortable: true,
  },
];
